/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Button from '@dtvgo/button';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './FocusableButtonProfile.scss';

export function BaseFocusableButtonProfile({
  children,
  type,
  primary,
  secondGray,
  className,
  disabled,
  bordered,
  focused,
  icon,
  onMouseDown,
  onMouseEnter,
  onClick,
}) {
  return (
    <Button
      type={type}
      primary={primary}
      secondGray={secondGray}
      className={
      `dtv-html5-c-focusable-button-profile ${
        focused ? 'dtv-html5-c-focusable-button-profile--focused' : ''
      } ${className}`
    }
      disabled={disabled}
      bordered={bordered}
      icon={icon}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}

BaseFocusableButtonProfile.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  primary: PropTypes.bool,
  secondGray: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  bordered: PropTypes.bool,
  focused: PropTypes.bool,
  icon: PropTypes.string,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onClick: PropTypes.func,
};

BaseFocusableButtonProfile.defaultProps = {
  children: undefined,
  type: 'button',
  primary: false,
  secondGray: false,
  className: '',
  disabled: false,
  bordered: false,
  focused: false,
  icon: '',
  onMouseDown: undefined,
  onMouseEnter: undefined,
  onClick: undefined,
};

export default memo(withInteractiveFocusable()(memo(BaseFocusableButtonProfile)));
